import { ApolloCache } from "@apollo/client";

import { Optional } from "@/features/common/type";
import {
  NotificationFullFragment,
  NotificationFullFragmentDoc,
} from "@/generated/generated-hooks";

type UpdateNotificationPageArgs = {
  cache: ApolloCache<object>;
  notification: Optional<NotificationFullFragment>;
};

export const updateNotificationPage = (args: UpdateNotificationPageArgs) => {
  const { cache, notification } = args;

  cache.modify({
    fields: {
      hasNotification(existing) {
        return true;
      },
    },
  });

  cache.modify({
    fields: {
      notificationPage(existing = {}, { readField }) {
        const itemRefs = readField("items", existing);

        const newNotificationRef = cache.writeFragment({
          data: notification,
          fragment: NotificationFullFragmentDoc,
        });

        const updatedItemRefs = [newNotificationRef, ...(itemRefs as any)];

        return {
          ...existing,
          items: [...updatedItemRefs],
          count: existing.count + 1,
        };
      },
    },
  });
};
